export default __webpack_public_path__ + "static/media/partner20.315ca853.webp";